
import Loading from 'vux/src/components/loading/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import DatetimeView from 'vux/src/components/datetime-view/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { getInvestorProduct } from 'api/investor'
export default {
components: {
Loading,
Group,
XHeader,
XInput,
Selector,
XNumber,
Datetime,
XButton,
Popup,
DatetimeView
},
data () {
return {
au: 'VS8rOW5LdmM2aVE2WFp3M1VtTHBiL0ZUWWEwZmVCWUp4S0hVVmlxbWZWbjc0aUkxcTkrNE9iT3FHMFU0RElNMQ==',
orgInfoType: 'fund', // 募集机构类型 orgType，fund:基金，futures：期货资管
loading: true,
type: 0,
isNormal: 1,
showPopup: false,
showCheckPopup: false,
todayDate: this.$util.getFormatDate(),
proTypeArry: [
'银行理财产品', '保险产品', '信托计划', '私募投资基金', '开放式公募基金产品', '封闭式公募基金产品', '基金公司专户',
'基金子公司产品', '保险公司及其子公司的资产管理计划', '证券公司集合理财产品', '证券公司专项资管计划', '证券公司定向资管计划',
'期货公司及其子公司的资产管理计划', '政府引导基金', '全国社保基金', '地方社保基金', '基本养老保险', '养老金产品', '企业年金及职业年金',
'境外资金（QFII）', '境外资金（RQFII）', '其它境外资金', '社会公益基金（慈善基金、捐赠基金等）', '其他产品'
],

data: {
productName: '111',
productType: '银行理财产品',
productRecordCode: '',
productFoundingDate: '',
productRecordDate: '',
productRecordNo: '',
productSurvivalPeriod: '',
productCategory: '私募证券投资基金',
productScale: '',
productManager: '',
productDeposit: '',
extendC: '',
extendD: ''
},
valid: {
productName: {code: '产品名称', is_success: ''},
productFoundingDate: {code: '成立时间', is_success: ''},
productSurvivalPeriod: {code: '存续期', is_success: ''},
productScale: {code: '产品规模', is_success: ''},
productManager: {code: '管理人', is_success: ''},
productDeposit: {code: '托管人', is_success: ''},

productRecordNo: {code: '备案编号', is_success: ''},
productRecordDate: {code: '备案时间', is_success: ''}
}
}
},
directives: {
TransferDom
},
computed: {
},
created () {
setTimeout(() => {
this.$vux.loading.show({text: '加载中'})
this.$bridge.registerHandler('getUpdate', this.$_product_update)
this.$_product_init()
}, this.initTime)
},
methods: {
$_product_update () {
this.type = 1
},
$_product_init () {
let _this = this

if (_this.isDev) {
if (_this.type === 0) {
_this.$_product_info(3, this.au)
}
_this.loading = false
_this.$vux.loading.hide()
} else {
_this.$bridge.callHandler('getUserInfo', {message: '新增/查看投资者信息, 参数type（1新增,0查看),isNormal(1是 0 否，string类型),extendC(管理员ID),extendD(投资者ID),productDealId(产品ID,查看时传入),au'}, function (data) {
_this.loading = false
_this.$vux.loading.hide()
let res = JSON.parse(data)
if (res.type && res.isNormal && res.au && res.extendD && res.extendC) {
_this.type = parseInt(res.type)
_this.isNormal = parseInt(res.isNormal)
_this.au = res.au
_this.data.extendC = res.extendC
_this.data.extendD = res.extendD
_this.orgInfoType = res.orgType
if (_this.type === 0) {
_this.$_product_info(res.productDealId, res.au)
} else {
_this.data.productName = res.productName
_this.data.productManager = res.productManager
}
} else {
_this.$vux.toast.show({
type: 'warn',
text: '信息获取失败'
})
}
})
}
},
$_product_info (productDealId, au) {
getInvestorProduct({productDealId: productDealId}, au).then((res) => {
if (res.code === 0) {
this.data = {
productName: res.data.bean.productInvenstement.productName,
productType: res.data.bean.productInvenstement.productType,
productRecordCode: res.data.bean.productInvenstement.productRecordCode,
productFoundingDate: res.data.bean.productInvenstement.productFoundingDate,
productRecordDate: res.data.bean.productInvenstement.productRecordDate,
productRecordNo: res.data.bean.productInvenstement.productRecordNo,
productSurvivalPeriod: res.data.bean.productInvenstement.productSurvivalPeriod,
productCategory: res.data.bean.productInvenstement.productCategory,
productScale: res.data.bean.productInvenstement.productScale,
productManager: res.data.bean.productInvenstement.productManager,
productDeposit: res.data.bean.productInvenstement.productDeposit,
extendC: res.data.bean.extendC,
extendD: res.data.bean.extendD,
oldInfo: JSON.stringify(res.data.bean.productInvenstement)
}
} else {
this.$vux.toast.show({
type: 'warn',
text: '信息获取失败'
})
}
})
},
$_product_next () {
if (this.type === 0) {
this.data.type = this.type
this.data.isNormal = this.isNormal
this.data.au = this.au
this.data.orgInfoType = this.orgType
this.$router.push({path: '/investor/product/two', query: this.data})
} else {
for (var item in this.valid) {
if (this.data[item] === '') {
console.log(this.data[item])
this.$vux.toast.show({
type: 'warn',
text: this.valid[item].code + '不能为空或输入不合规范'
})
return

}







}
this.data.type = this.type
this.data.isNormal = this.isNormal
this.data.au = this.au
this.data.orgInfoType = this.orgType
this.$router.push({path: '/investor/product/two', query: this.data})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/InvestorInfo/Product/One.vue